export const html = `
<head>
  <style>
    * {
      font-size: 1rem;
      color: #666;
    }

    p {
      margin: 1rem 0;
      font-size: 1rem;
      color: #666;
    }
    ul, ol {
      padding-left: 1.125rem;
      margin-left: 10px;
    }

    ul li {
      margin-bottom: 10px;
      list-style-type: disc;
    }

    ol[type=I] li{
      font-weight: bold;
      list-style-type: upper-roman;
    }
    ol[type=a] li{
        list-style-type: lower-alpha;
    }
  </style>
</head>
<main>
    <center>
        <u><strong>POLÍTICA DE PRIVACIDADE</strong></u><br />
        <span><strong>PORTAL DE SAÚDE DUQUE DE CAXIAS</strong></span>
    </center>

    <p>No Fundo Municipal de Saúde de Duque de Caxias, privacidade e segurança são prioridades, e nos comprometemos com a transparência do tratamento de dados pessoais e dados pessoais sensíveis dos nossos usuários/clientes/colaboradores. Por essa razão, a presente Política de Privacidade estabelece como é feita a coleta, uso e transferência de informações de clientes ou outras pessoas que acessam ou utilizam nosso software/site/aplicativo.</p>

    <p>Ao usufruir dos nossos serviços, você compreende que coletaremos e usaremos suas informações pessoais nas formas descritas nesta Política, sob as normas de Proteção de Dados (LGPD, Lei Federal 13.709/2018), das disposições consumeristas da Lei Federal 8078/1990 e as demais normas do ordenamento jurídico brasileiro aplicáveis.</p>

    <p>Como condição para acesso e uso das funcionalidades exclusivas dos nossos ambientes, você DECLARA que fez a leitura completa e atenta desta Política, estando plenamente ciente, conferindo, assim, sua livre e expressa concordância com os termos aqui estipulados, incluindo a coleta dos dados aqui mencionados, bem como sua utilização para os fins abaixo especificados. Caso não esteja de acordo com as disposições desta Política, você deverá descontinuar o seu acesso ou uso dos nossos ambientes.</p>

    <p>Desta maneira, o FUNDO MUNICIPAL DE SAÚDE DE DUQUE DE CAXIAS, doravante denominada como “PORTAL DE SAÚDE DUQUE DE CAXIAS”, inscrita no CNPJ sob o nº 11.128.809/0001-10, no papel de Controladora de Dados, obriga-se ao disposto na presente Política de Privacidade.</p>
    <ol type="I">
    <li><strong>QUAIS DADOS COLETAMOS DO USUÁRIO E COMO RECOLHEMOS?</strong></li>
    </ol>

    <p>O <strong>PORTAL DE SAÚDE DUQUE DE CAXIAS</strong> coleta e utiliza dados pessoais seus, de forma a viabilizar a prestação do serviço personalizado da empresa e aprimorar a sua experiência de uso.</p>

    <p>Os dados coletados são:</p>

    <p><u>Dados pessoais e pessoais sensíveis:</u></p>

    <p>São fornecidos pelo titular para a criação da conta/perfil no site/aplicativo “PORTAL DE SAÚDE DUQUE DE CAXIAS”.</p>

    <p>Quando o usuário cria uma conta/perfil no site/aplicativo “PORTAL DE SAÚDE DUQUE DE CAXIAS”, esses dados são os de identificação básicos e dados de anamnese do usuário.</p>

    <p>A partir deles, podemos identificá-lo, além de garantir uma maior segurança e bem-estar às suas necessidades. São eles:</p>

    <ul>
        <li><strong>Nome Completo;</strong></li>
        <li><strong>E-mail;</strong></li>
        <li><strong>CPF;</strong></li>
        <li><strong>Telefone.</strong></li>
    </ul>

    <p><u>Dados Críticos:</u></p>
    <ul>
        <li><strong>Imagem (ao permitir o uso da câmera);</strong></li>
        <li><strong>Voz (ao permitir o uso do microfone).</strong></li>
    </ul>

    <p><u>Dados relacionados ao Contrato de Prestação de Serviços:</u></p>

    <p>Diante da formalização do Contrato de Prestação de Serviços realizados entre o <strong>PORTAL DE SAÚDE DUQUE DE CAXIAS</strong> e o usuário, poderão ser coletados e armazenados dados relativos à execução contratual, inclusive as comunicações realizadas entre a empresa e o usuário; registro em banco de dados de quaisquer arquivos ou informações carregadas no aplicativo pelos usuários ou profissionais de saúde.</p>

    <p>Estes dados expressos acima também poderão ser coletados através de informações inseridas ativamente por você, “Usuário”, no momento do contato ou cadastro (através do preenchimento do formulário de contato ou pelo ambiente online) e, ainda, informações coletadas automaticamente de você, ao utilizar os nossos serviços, como, por exemplo, dados atrelados a sua conexão, tais como: endereço de IP, data, hora, dispositivo utilizado, dados de consumo e hábitos de utilização, dentre outras informações.</p>
    <ol start="2" type="I">
    <li><strong>PARA QUAIS FINALIDADES UTILIZAMOS OS DADOS PESSOAIS DO USUÁRIO?</strong></li>
    </ol>
    <ol type="a">
    <li>

    <p>Para cadastro e identificação do usuário no software/site/app do <strong>PORTAL DE SAÚDE DUQUE DE CAXIAS</strong>, bem como fazer a disponibilização dos conteúdos oferecidos pela plataforma, exclusivo para usuários cadastrados.</p>
    </li>
    <li>

    <p>Aprimorar o produto e serviço oferecido, facilitar, agilizar e cumprir os compromissos firmados entre o usuário e a empresa, bem como melhorar e garantir que as funcionalidades oferecidas sejam apresentadas de forma eficiente para o usuário.</p>
    </li>
    <li>

    <p>Compreender como o usuário utiliza os serviços da plataforma, a fim de ajudar no desenvolvimento e melhorias na plataforma.</p>
    </li>
    <li>

    <p>Tratamentos automatizados de dados pessoais para previsão do perfil do usuário e avaliar o seu uso na plataforma.</p>
    </li>
    <li>

    <p>Conferir às partes segurança jurídica e facilitar a conclusão do negócio.</p>
    </li>
    <li>

    <p>Garantir o monitoramento preventivo do usuário pela equipe de saúde multidisciplinar do<strong> PORTAL DE SAÚDE DUQUE DE CAXIAS</strong>.</p>
    </li>
    <li>

    <p>Criação de um banco de dados para análise e projeções em proveito da sociedade empresária, priorizando a anonimização dos dados e a segurança com o manuseio e o armazenamento dessas informações através de softwares com criptografia e limitação de acesso.</p>
    </li>
    <li>

    <p>Quando necessário, para o cumprimento de obrigação legal ou regulatória ou exercício regular de direitos em processo judicial, administrativo ou arbitral.</p>
    </li>
    </ol>

    <p>O <strong>PORTAL DE SAÚDE DUQUE DE CAXIAS</strong> poderá utilizar as suas informações em demais serviços prestados diretamente pela por ela, respeitadas as finalidades expostas e mediante coleta do consentimento, quando exigido por Lei.</p>

    <p>Além disso, o <strong>PORTAL DE SAÚDE DUQUE DE CAXIAS</strong> também poderá tratar dados pessoais com base em seu interesse legítimo, sempre no limite de sua expectativa, e nunca em prejuízo de seus interesses, direitos e liberdades fundamentais.</p>

    <p>O tratamento de dados pessoais para finalidades não previstas nesta Política de Privacidade somente ocorrerá mediante comunicação prévia ao usuário, de forma que os direitos e obrigações aqui previstos permanecem aplicáveis.</p>
    <ol start="3" type="I">
    <li><strong>CONSENTIMENTO</strong></li>
    </ol>

    <p>Os seus dados pessoais e dados pessoais sensíveis serão tratados pelo <strong>PORTAL DE SAÚDE DUQUE DE CAXIAS </strong>a partir do seu consentimento. O consentimento é a manifestação livre, informada e inequívoca pela qual você autoriza o tratamento de seus dados.</p>

    <p>Deste modo, em conformidade com a Lei Geral de Proteção de Dados, seus dados só serão coletados, tratados e armazenados mediante prévio e expresso consentimento. O seu consentimento será obtido de forma específica para cada finalidade acima descrita, evidenciando o compromisso de transparência e boa-fé do <strong>PORTAL DE SAÚDE DUQUE DE CAXIAS</strong> para com seus usuários, seguindo as regulações legislativas pertinentes.</p>

    <p>Ao utilizar os serviços do <strong>PORTAL DE SAÚDE DUQUE DE CAXIAS</strong> e fornecer seus dados pessoais, você está ciente e consentindo com as disposições desta Política de Privacidade, além de conhecer seus direitos e como exercê-los.</p>

    <p>A qualquer tempo e sem nenhum ônus, você poderá revogar seu consentimento. O Usuário fica ciente, por meio da leitura deste documento, que a eventual solicitação de exclusão de informações essenciais para a gestão de seu cadastro junto o <strong>PORTAL DE SAÚDE DUQUE DE CAXIAS</strong> implicará no término de sua relação contratual, com o consequente cancelamento dos serviços então prestados.</p>

    <p>O Usuário fica ciente também, de que apesar da solicitação de exclusão, pode ocorrer que os Dados precisem ser mantidos por período superior ao pedido de exclusão, nos termos do artigo 16 da Lei Geral de Proteção de Dados Pessoais, o qual serão delimitados em tópico próprio.</p>
    <ol start="4" type="I">
    <li><strong>QUAIS SÃO OS SEUS DIREITOS?</strong></li>
    </ol>

    <p><strong>O PORTAL DE SAÚDE DUQUE DE CAXIAS</strong> garante a seus usuários seus direitos de titular dispostos no artigo 18 da Lei Geral de Proteção de Dados. Assim, você pode, de maneira gratuita e a qualquer tempo:</p>
    <ol type="a">
    <li>

    <p>Confirmar a existência de tratamento de dados, de maneira simplificada ou em formato claro e completo;</p>
    </li>
    <li>

    <p>Acessar seus dados, podendo solicitá-los em uma cópia legível por meio eletrônico, seguro e idôneo;</p>
    </li>
    <li>

    <p>Corrigir seus dados, ao solicitar a edição, correção ou atualização destes;</p>
    </li>
    <li>

    <p>Limitar seus dados quando desnecessários, excessivos ou tratados em desconformidade com a legislação através da anonimização, bloqueio ou eliminação;</p>
    </li>
    <li>

    <p>Solicitar a portabilidade de seus dados, através de um relatório de dados cadastrais que o <strong>PORTAL DE SAÚDE DUQUE DE CAXIAS</strong> trata a seu respeito;</p>
    </li>
    <li>

    <p>Eliminar seus dados tratados a partir de seu consentimento, exceto nos casos previstos em lei;</p>
    </li>
    <li>

    <p>Revogar seu consentimento, desautorizando o tratamento de seus dados;</p>
    </li>
    <li>

    <p>Informar-se sobre a possibilidade de não fornecer seu consentimento e sobre as consequências da negativa.</p>
    </li>
    </ol>

    <p><strong>O PORTAL DE SAÚDE DUQUE DE </strong>CAXIAS empreenderá todos os esforços razoáveis para atender as requisições feitas por Usuários no menor espaço de tempo possível. No entanto, fatores justificáveis, tais como a complexidade da ação requisitada, poderão atrasar ou impedir o seu rápido atendimento, sendo certo que, em caso de demora, a Controladora apresentará ao Usuário os devidos motivos.</p>

    <p>Por fim, o Usuário deve estar ciente que a sua requisição poderá ser legalmente rejeitada, seja por motivos formais (a exemplo de sua incapacidade de comprovar sua identidade) ou legais (aexemplo do pedido de exclusão de dados cuja manutenção é livre exercício de direito pela <strong>PORTAL DE SAÚDE DUQUE DE CAXIAS</strong>), sendo certo que, na hipótese de impossibilidade de atendimento destas requisições, o <strong>PORTAL DE SAÚDE DUQUE DE CAXIAS</strong> apresentará ao Usuário as justificativas razoáveis.</p>

    <p>O Usuário reconhece que toda comunicação realizada por e-mail (aos endereços informados no seu cadastro), SMS, aplicativos de comunicação instantânea ou qualquer outra forma digital, também são válidas, eficazes e suficientes para a divulgação de qualquer assunto que se refira aos serviços que prestamos, aos seus dados, bem como às condições de sua prestação ou a qualquer outro assunto nele abordado, sendo exceção apenas o que essa Política prever como tal.</p>

    <p>Ressalva-se que caso algum ponto desta Política seja considerado inaplicável por Autoridade de Dados ou judicial, as demais condições permanecerão em pleno vigor e efeito.</p>
    <ol start="5" type="I">
    <li><strong>COMO E POR QUANTO TEMPO SEUS DADOS SERÃO ARMAZENADOS?</strong></li>
    </ol>

    <p>Seus dados pessoais coletados pelo<strong> PORTAL DE SAÚDE DUQUE DE CAXIAS</strong> serão utilizados e armazenados durante o tempo necessário para a prestação do serviço ou para que as finalidades elencadas na presente Política de Privacidade sejam alcançadas, considerando os direitos dos titulares dos dados e dos controladores.</p>

    <p>Desta forma, seus dados serão mantidos enquanto a relação contratual entre você e o<strong> PORTAL DE SAÚDE DUQUE DE CAXIAS </strong>existir.</p>

    <p>Concluído o período de armazenamento dos dados pessoais, estes serão excluídos de nossas bases de dados ou anonimizados, excetuadas as hipóteses legalmente previstas no artigo 16 Lei Geral de Proteção de Dados, abaixo descritos:</p>
    <ol type="a">
    <li>

    <p>Cumprimento de obrigação legal ou regulatória pela Controladora;</p>
    </li>
    <li>

    <p>Estudo por órgão de pesquisa, garantida, sempre que possível, a anonimização dos dados pessoais;</p>
    </li>
    <li>

    <p>Transferência a terceiro, desde que respeitados os requisitos de tratamento de dados dispostos nesta Lei; ou</p>
    </li>
    <li>

    <p>Uso exclusivo da Controladora, vedado seu acesso por terceiro, e desde que anonimizados os dados.</p>
    </li>
    </ol>

    <p>As disposições acima mencionadas referem-se às informações pessoais sobre você que sejam imprescindíveis para o cumprimento de determinações legais, judiciais, administrativas e/ou para o exercício do direito de defesa em processos judiciais e administrativos.</p>

    <p>O armazenamento de dados coletados pelo<strong> PORTAL DE SAÚDE DUQUE DE CAXIAS </strong>representa o nosso compromisso com a segurança e privacidade dos seus dados. Utilizamos medidas e soluções técnicas de proteção para garantir a confidencialidade, integridade e inviolabilidade dos seus dados. Além disso, também contamos com medidas de segurança apropriadas aos riscos e com controle de acesso às informações armazenadas.</p>

    <p>Findos o prazo de manutenção e a necessidade legal, os Dados Pessoais serão excluídos com uso de métodos de descarte seguro, ou utilizados de forma anonimizadas para fins estatísticos.</p>
    <ol start="6" type="I">
    <li><strong>O QUE O PORTAL DE SAÚDE DUQUE DE CAXIAS FARÁ PARA MANTER SEUS DADOS SEGUROS?</strong></li>
    </ol>

    <p>A fim de mantermos suas informações seguras, usamos ferramentas físicas, eletrônicas e gerenciais orientadas para a proteção da sua privacidade.</p>

    <p>Aplicamos essas ferramentas levando em consideração a natureza dos dados coletados, o contexto e a finalidade do tratamento e os riscos que eventuais violações gerariam para os direitos e liberdades do titular dos dados coletados e tratados.</p>

    <p>Dentre as medidas que adotamos, destacamos as seguintes:</p>
    <ol type="a">
    <li>

    <p>O<strong> PORTAL DE SAÚDE DUQUE DE CAXIAS </strong>utiliza os mais recentes métodos e equipamentos disponíveis no mercado para criptografar e anonimizar os seus dados, quando necessário e cuja a sua finalidade assim permita;</p>
    </li>
    <li>

    <p>Apenas pessoas autorizadas possuem acesso a seus dados pessoais, sendo administrado um controle rigoroso com histórico de acesso;</p>
    </li>
    <li>

    <p>O acesso a seus dados pessoais é feito somente após o compromisso de confidencialidade;</p>
    </li>
    <li>

    <p>O<strong> PORTAL DE SAÚDE DUQUE DE CAXIAS</strong> garante que aqueles agentes, funcionários internos ou parceiros externos que realizarem o tratamento de dados pessoais deverão se comprometer a manter o sigilo absoluto das informações acessadas, bem como de adotar as melhores práticas para manuseio destas informações, conforme determinado nas políticas e procedimentos externos;</p>
    </li>
    <li>

    <p>Seus dados pessoais são armazenados em ambiente seguro e idôneo;</p>
    </li>
    <li>

    <p>Utilização de softwares e criptografia de ponta a ponta para minimizar qualquer possibilidade de vazamento de dados;</p>
    </li>
    <li>

    <p>Utilização de códigos exclusivos para a equipe de saúde no tratamento de informações sensíveis dos titulares, com o objetivo de possibilitar os manuseios das informações apenas por estes profissionais.</p>
    </li>
    </ol>

    <p>Além dos esforços técnicos,o<strong> PORTAL DE SAÚDE DUQUE DE CAXIAS </strong>também adota medidas institucionais visando a proteção de dados pessoais, de modo que mantém programa de governança em privacidade aplicado às suas atividades e estrutura de governança, constantemente atualizado.</p>

    <p>O acesso às informações coletadas é restrito aos colaboradores e às pessoas autorizadas. Aqueles que se utilizarem indevidamente dessas informações, em violação desta Política de Privacidade e Segurança da Informação, estarão sujeitos a sanções administrativas, disciplinares e legais cabíveis.</p>

    <p>O<strong>PORTAL DE SAÚDE DUQUE DE CAXIAS </strong>se compromete a adotar as melhores atitudes para evitar incidentes de segurança. No entanto, é preciso destacar que nenhuma página virtual ou qualquer transmissão de informação é inteiramente segura e livre de riscos. Desta forma o <strong>PORTAL DE SAÚDE DUQUE DE CAXIAS</strong> não pode garantir integralmente que todas as informações que recebe e/ou envia não sejam alvo de acessos não autorizados perpetrados por meio de métodos desenvolvidos para obter informações de forma indevida, como falhas técnicas, vírus ou invasões do banco de dados do site. De todo modo, na remota hipótese de incidência de episódios desta natureza, o<strong> PORTAL DE SAÚDE DUQUE DE CAXIAS</strong> garante o pleno esforço para remediar as consequências do evento danoso.</p>

    <p>Em caso de incidentes de segurança que possam gerar risco ou dano relevante para você ou qualquer um de nossos usuários, comunicaremos aos afetados e a Autoridade Nacional de Proteção de Dados sobre o ocorrido, em consonância com as disposições da Lei Geral de Proteção de Dados.</p>
    <ol start="7" type="I">
    <li><strong>COM QUEM SEUS DADOS PODERÃO SER COMPARTILHADOS?</strong></li>
    </ol>

    <p>Levando em consideração a preservação de sua privacidade, o<strong> PORTAL DE SAÚDE DUQUE DE CAXIAS</strong> não compartilhará seus dados pessoais com nenhum terceiro que não for autorizado.</p>

    <p>Além disso, também existem outras hipóteses em que seus dados poderão ser compartilhados, que são:</p>
    <ol type="a">
    <li>

    <p>Determinação legal, requerimento, requisição ou ordem judicial, com autoridades judiciais, administrativas ou governamentais competentes;</p>
    </li>
    <li>

    <p>Caso de movimentações societárias, como fusão, aquisição e incorporação, de forma automática;</p>
    </li>
    <li>

    <p>Proteção dos direitos do PORTAL<strong> DE SAÚDE DUQUE DE CAXIAS</strong> Á em qualquer tipo de conflito, inclusive os de teor judicial.</p>
    </li>
    </ol>

    <p>Nesse sentido, o <strong>PORTAL DE SAÚDE DUQUE DE CAXIAS</strong> se compromete a sempre adotar eficientes padrões de segurança cibernética e de proteção de dados, nos melhores esforços de garantir e cumprir as exigências legislativas.</p>

    <p>Ao concordar com esta Política de Privacidade, você concorda com este compartilhamento, que se dará conforme as finalidades descritas no presente instrumento.</p>
    <ol start="8" type="I">
    <li><strong>COOKIES OU DADOS DE NAVEGAÇÃO</strong></li>
    </ol>

    <p>Os cookies referem-se a arquivos de texto enviados pela plataforma ao computador do usuário e visitante e que nele ficam armazenados, com informações relacionadas à navegação no site. Estas informações são relacionadas aos dados de acesso como local e horários de acesso e são armazenados pelo navegador do usuário e visitante para que o servidor da plataforma possa lê-las posteriormente a fim de personalizar os serviços da plataforma.</p>

    <p>Portanto, o usuário da plataforma <strong>PORTAL DE SAÚDE DUQUE DE CAXIAS</strong> manifesta conhecer e aceitar que pode ser utilizado um sistema de coleta de dados de navegação mediante à utilização de cookies.</p>

    <p>Os cookies persistentes permanecem no disco rígido do usuário depois que o navegador é fechado e serão usados pelo navegador em visitas subsequentes ao site. Os cookies persistentes podem ser removidos seguindo as instruções do seu navegador. Já o cookie de sessão é temporário e desaparece depois que o navegador é fechado. é possível redefinir seu navegador da web para recusar todos os cookies, mas alguns recursos da plataforma podem não funcionar corretamente se a capacidade de aceitar cookies estiver desabilitada.</p>
    <ol start="9" type="I">
    <li><strong>ALTERAÇÃO DA POLÍTICA DE PRIVACIDADE</strong></li>
    </ol>

    <p><strong>A atual versão desta Política de Privacidade foi formulada e atualizada pela última vez em: 22 de julho de 2026</strong>. Reservamos o direito de modificar essa Política de Privacidade a qualquer tempo, principalmente em função da adequação a eventuais alterações feitas em nossos softwares ou em âmbito legislativo. Recomendamos que você a revise com frequência.</p>

    <p>Eventuais alterações entrarão em vigor a partir de sua publicação em nosso site/aplicativo e sempre lhe notificaremos acerca das mudanças ocorridas. Ao utilizar nossos serviços e fornecer seus dados pessoais após tais modificações, você as consente.</p>
    <ol start="10" type="I">
    <li><strong>RESPONSABILIDADE</strong></li>
    </ol>

    <p>O<strong> PORTAL DE SAÚDE DUQUE DE CAXIAS </strong>prevê a responsabilidade dos agentes que atuam nos processos de tratamento de dados, de acordo com os artigos 42 ao 45 da Lei Geral de Proteção de Dados. Nos comprometemos em manter esta Política de Privacidade atualizada, observando suas disposições e zelando por seu cumprimento.</p>

    <p>Ademais, assumimos o compromisso de encontrar condições técnicas e seguras aptas a proteger todo o processo de tratamento de dados. Caso a Autoridade Nacional de Proteção de Dados exija a adoção de providências em relação ao tratamento de dados realizado pelo <strong>PORTAL DE SAÚDE DUQUE DE CAXIAS</strong>, teremos o compromisso de segui-las.</p>
    <ol start="11" type="I">
    <li><strong>ISENÇÃO DE RESPONSABILIDADE</strong></li>
    </ol>

    <p>Embora adotemos altos padrões de segurança com o intuito de evitar incidentes, não há nenhuma transmissão de informação inteiramente livre de riscos.</p>

    <p>Nesse sentido, o <strong>PORTAL DE SAÚDE DUQUE DE CAXIAS</strong> não se responsabiliza por:</p>
    <ol type="a">
    <li>

    <p>Quaisquer consequências decorrentes da negligência, imprudência ou imperícia dos usuários em relação a seus dados individuais. Garantimos e nos responsabilizamos apenas pela segurança dos processos de tratamento de dados e do cumprimento das finalidades descritas no presente instrumento. Destacamos que a responsabilidade em relação à confidencialidade dos dados de acesso é do usuário;</p>
    </li>
    <li>

    <p>Ações maliciosas de terceiros, como ataques de hackers, exceto se comprovada conduta culposa ou deliberada do <strong>PORTAL DE SAÚDE DUQUE DE CAXIAS</strong> Destacamos que em caso de incidentes de segurança que possam gerar risco ou dano relevante para você ou qualquer um de nossos usuários, comunicaremos aos afetados e a Autoridade Nacional de Proteção de Dados sobre o ocorrido e cumpriremos as providências necessárias;</p>
    </li>
    <li>

    <p>Inveracidade das informações inseridas pelo usuário nos registros necessários para a utilização dos serviços do <strong>PORTAL DE SAÚDE DUQUE DE CAXIAS</strong>. Quaisquer consequências decorrentes de informações falsas ou inseridas de má-fé são de inteira responsabilidade do usuário/cliente.</p>
    </li>
    </ol>
    <ol start="12" type="I">
    <li><strong>JURISDIÇÃO PARA RESOLUÇÃO DE CONFLITOS</strong></li>
    </ol>

    <p>Para a solução de controvérsias decorrentes do presente instrumento será aplicado integralmente o Direito brasileiro. Os eventuais litígios deverão ser apresentados no foro da Comarca <strong>de Duque de Caxias/RJ</strong>, com expressa renúncia de qualquer outro, ainda que privilegiado, para o fim de dirimir eventuais dúvidas oriundas deste instrumento<strong>.</strong></p>

    <p><u><strong>TERMOS E CONDIÇÕES GERAIS DE USO DO PORTAL DE SAÚDE DUQUE DE CAXIAS</strong></u></p>

    <p>Por meio deste instrumento, a pessoa jurídica FUNDO MUNICIPAL DE DUQUE DE CAXIAS, associação jurídica de direito privado, sem fins lucrativos, regularmente inscrita no CNPJ sob o nº 11.128.809/0001-10, estabelece os Termos de Uso aplicáveis ao Portal de Saúde Duque de Caxias, de modo a descrever as obrigações, direitos e responsabilidades de seus Usuários.</p>
    <ol type="I">
    <li><strong>DO OBJETO</strong></li>
    </ol>

    <p>A plataforma visa licenciar o uso de seu software, aplicativos, website e demais ativos de sua propriedade intelectual ou os quais possui autorização, fornecendo ferramentas para auxiliar e dinamizar o dia a dia dos seus usuários.</p>

    <p>Desta forma, o <strong>PORTAL DE SAÚDE DUQUE DE CAXIAS</strong> realiza a prestação dos seguintes serviços: Serviços de teleconsultas, através do <strong>PORTAL DE SAÚDE DUQUE DE CAXIAS.</strong></p>
    <ol start="2" type="I">
    <li><strong>DA ACEITAÇÃO</strong></li>
    </ol>

    <p>O presente Termo estabelece obrigações contratadas de livre e espontânea vontade, durante o tempo de vigência contratado pelo usuário, entre a plataforma e os usuários do <strong>PORTAL DE SAÚDE DUQUE DE CAXIAS.</strong></p>

    <p>Ao utilizar a plataforma, o usuário aceita integralmente as presentes normas e compromete-se a observá-las, sob o risco de aplicação das penalidades cabíveis.</p>

    <p>A aceitação do presente instrumento é imprescindível para o acesso e para a utilização de quaisquer serviços fornecidos pela empresa. Caso não concorde com as disposições deste instrumento, o usuário não deve utilizá-los.</p>
    <ol start="3" type="I">
    <li><strong>DO ACESSO DOS USUÁRIOS</strong></li>
    </ol>

    <p>A navegação na plataforma ou em alguma de suas páginas poderá ser interrompida, limitada ou suspensa para atualizações, modificações ou qualquer ação necessária ao seu bom funcionamento.</p>
    <ol start="4" type="I">
    <li><strong>DO CADASTRO</strong></li>
    </ol>

    <p>Para que o usuário tenha acesso às funcionalidades do <strong>PORTAL DE SAÚDE DUQUE DE CAXIAS</strong>, este deverá, de forma obrigatória, realizar seu cadastro prévio. O usuário deverá, também, aceitar o Contrato de Prestação de Serviços do <strong>PORTAL DE SAÚDE DUQUE DE CAXIAS</strong> e demais termos de consentimento.</p>
    <ol type="a">
    <li>

    <p>Ao acessar o <strong>PORTAL DE SAÚDE DUQUE DE CAXIAS, </strong>o usuário deverá permitir o uso de câmera e microfone.</p>
    </li>
    <li>

    <p>Ao realizar o seu cadastro, o usuário deverá informar seus dados completos, recentes, verdadeiros e válidos, quais sejam, CPF, e-mail, nome completo e telefone, sendo de sua exclusiva responsabilidade manter os referidos dados atualizados.</p>
    </li>
    <li>

    <p>O usuário se compromete a não informar seus dados cadastrais e/ou de acesso ao aplicativo a terceiros, responsabilizando-se integralmente pelo uso que deles seja feito.</p>
    </li>
    <li>

    <p>Mediante a realização do cadastro, o usuário declara e garante expressamente ser plenamente capaz, podendo exercer e usufruir livremente dos serviços e produtos.</p>
    </li>
    <li>

    <p>Menores de 18 anos, bem como aqueles que não possuírem plena capacidade civil deverão obter previamente o consentimento expresso de seus responsáveis legais para utilização da plataforma e dos serviços ou produtos, sendo de responsabilidade exclusiva destes o eventual acesso por menores de idade e por aqueles que não possuem plena capacidade civil sem a prévia autorização.</p>
    </li>
    <li>

    <p>O usuário deverá fornecer um endereço de e-mail válido, através do qual o site realizará todas as comunicações necessárias.</p>
    </li>
    <li>

    <p>Após a confirmação do cadastro, o usuário possuirá um login e uma senha pessoal, a qual assegurará ao usuário o acesso individual a mesma. Desta forma, compete ao usuário exclusivamente a manutenção de referida senha de maneira confidencial e segura, evitando o acesso indevido às informações pessoais.</p>
    </li>
    <li>

    <p>Toda e qualquer atividade realizada com o uso da senha será de responsabilidade do usuário, que deverá informar prontamente a plataforma em caso de uso indevido da respectiva senha.</p>
    </li>
    <li>

    <p>Não será permitido ceder, vender, alugar ou transferir, de qualquer forma, a conta, que é pessoal e intransferível.</p>
    </li>
    <li>

    <p>Caberá ao usuário assegurar que o seu equipamento seja compatível com as características técnicas que viabilize a utilização da plataforma e dos serviços ou produtos.</p>
    </li>
    </ol>
    <ol start="5" type="I">
    <li><strong>DOS SERVIÇOS PRESTADOS</strong></li>
    </ol>
    <ol type="a">
    <li>

    <p>Teleconsultas com equipe multiprofissional.</p>
    </li>
    </ol>
    <ol start="6" type="I">
    <li><strong>DAS RESPONSABILIDADES</strong></li>
    </ol>

    <p>é de responsabilidade do usuário:</p>
    <ol type="a">
    <li>

    <p>Defeitos ou vícios técnicos originados no próprio sistema do usuário;</p>
    </li>
    <li>

    <p>A correta utilização da plataforma, dos serviços ou produtos oferecidos, prezando pela boa convivência, pelo respeito e cordialidade;</p>
    </li>
    <li>

    <p>Pelo cumprimento e respeito ao conjunto de regras disposto nesse Termo de Condições Geral de Uso, na respectiva Política de Privacidade e na legislação nacional e internacional;</p>
    </li>
    <li>

    <p>Pela proteção aos dados de acesso à sua conta/perfil (login e senha).</p>
    </li>
    </ol>

    <p>é de responsabilidade do <strong>PORTAL DE SAÚDE DUQUE DE CAXIAS:</strong></p>
    <ol type="a">
    <li>

    <p>Indicar as características do serviço ou produto;</p>
    </li>
    <li>

    <p>Os defeitos e vícios encontrados no serviço ou produto oferecido desde que lhe tenha dado causa;</p>
    </li>
    <li>

    <p>As informações que foram por ele divulgadas, sendo que os comentários ou informações divulgadas por usuários são de inteira responsabilidade dos próprios usuários;</p>
    </li>
    <li>

    <p>Os conteúdos ou atividades ilícitas praticadas através da sua plataforma.</p>
    </li>
    </ol>

    <p>A plataforma não se responsabiliza por links externos contidos em seu sistema que possam redirecionar o usuário à ambiente externo a sua rede.</p>

    <p>Não poderão ser incluídos links externos ou páginas que sirvam para fins comerciais ou publicitários ou quaisquer informações ilícitas, violentas, polêmicas, pornográficas, xenofóbicas, discriminatórias ou ofensivas.</p>
    <ol start="7" type="I">
    <li><strong>DOS DIREITOS AUTORAIS</strong></li>
    </ol>

    <p>O presente Termo de Uso concede aos usuários uma licença não exclusiva, não transferível e não sublicenciável, para acessar e fazer uso da plataforma e dos serviços e produtos por ela disponibilizados.</p>

    <p>A estrutura do site ou aplicativo, as marcas, logotipos, nomes comerciais, layouts, gráficos e design de interface, imagens, ilustrações, fotografias, apresentações, vídeos, conteúdos escritos e de som e áudio, programas de computador, banco de dados, arquivos de transmissão e quaisquer outras informações e direitos de propriedade intelectual da razão social<strong> FUNDO MUNICIPAL DE SAÚDE DE DUQUE DE CAXIAS, </strong>observados os termos da Lei da Propriedade Industrial (Lei nº 9.279/96), Lei de Direitos Autorais (Lei nº 9.610/98) e Lei do Software (Lei nº 9.609/98).</p>

    <p>Este Termo de Uso não cede ou transfere ao usuário qualquer direito, de modo que o acesso não gera qualquer direito de propriedade intelectual ao usuário, exceto pela licença limitada ora concedida.</p>

    <p>O uso da plataforma pelo usuário é pessoal, individual e intransferível, sendo vedado qualquer uso não autorizado, comercial ou não-comercial. Tais usos consistirão em violação dos direitos de propriedade intelectual da razão social <strong>FUNDO MUNICIPAL DE SAÚDE DE DUQUE DE CAXIAS, </strong>puníveis nos termos da legislação aplicável.</p>
    <ol start="8" type="I">
    <li><strong>DAS SANÇÕES</strong></li>
    </ol>

    <p>Sem prejuízo das demais medidas legais cabíveis, a razão <strong>social FUNDO MUNICIPAL DE SAÚDE DE DUQUE DE CAXIAS</strong> poderá, a qualquer momento, advertir, suspender ou cancelar a conta do usuário:</p>
    <ol type="a">
    <li>

    <p>Que violar qualquer dispositivo do presente Termo;</p>
    </li>
    <li>

    <p>Que descumprir os seus deveres de usuário;</p>
    </li>
    <li>

    <p>Que tiver qualquer comportamento fraudulento, doloso ou que ofenda a terceiros.</p>
    </li>
    </ol>
    <ol start="9" type="I">
    <li><strong>DA RESCISÃO</strong></li>
    </ol>

    <p>A não observância das obrigações pactuadas neste Termo de Uso ou da legislação aplicável poderá, sem prévio aviso, ensejar a imediata rescisão unilateral por parte da razão social <strong>FUNDO MUNICIPAL DE SAÚDE DE DUQUE DE CAXIAS</strong>. E o bloqueio de todos os serviços prestados ao usuário.</p>
    <ol start="10" type="I">
    <li><strong>DAS ALTERAÇÕES</strong></li>
    </ol>

    <p>Os itens descritos no presente instrumento poderão sofrer alterações, unilateralmente e a qualquer tempo, a fim de adequar ou modificar os serviços, bem como para atender novas exigências legais. As alterações serão veiculadas pelo <strong>PORTAL DE SAÚDE DUQUE DE CAXIAS.</strong></p>
    <ol start="11" type="I">
    <li><strong>DA POLÍTICA DE PRIVACIDADE</strong></li>
    </ol>

    <p>Além do presente Termo, o usuário deverá consentir com as disposições contidas na respectiva Política de Privacidade a ser apresentada a todos os interessados dentro da interface da plataforma.</p>
    <ol start="12" type="I">
    <li><strong>DO FORO</strong></li>
    </ol>

    <p>Para a solução de controvérsias decorrentes do presente instrumento será aplicado integralmente o Direito brasileiro.</p>

    <p>Os eventuais litígios deverão ser apresentados no foro da Comarca de Duque de Caxias/RJ, com expressa renúncia de qualquer outro, ainda que seja mais privilegiado.</p>

    <p><strong>ACEITE</strong>: Em virtude das cláusulas do presente Contrato, o USUÁRIO declara que concorda integralmente com todas as disposições nele contidas, obrigando-se, desde já, a respeitá-las durante toda a vigência de contratação da <strong>PORTAL DE SAÚDE DUQUE DE CAXIAS.</strong></p>
</main>
`